import { Box } from '@mui/material';

import { ClientReportTable } from 'modules/components/layer25';
import { ActivitySectionLayout } from 'modules/components/layer32';
import React from 'react';



export type ClientReportsDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportsDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <Box
        minHeight='60vh'
      >

        <ClientReportTable.FC />
      </Box>
    </ActivitySectionLayout.FC>

  );
};
